import React from 'react';
import { Wrapper, Heading, Portfolio, PortfolioPicture, PortfolioTitle, AmountOfPortfolios, PortfolioTitleJP, AmountOfPortfoliosJP, Description, Link, BigSection, SmallSection } from './index.styled';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';

export const AvailablePortfolioCategories = () => {
  const { t } = useTranslation();
  const portfolioCategories = t(`PortfolioCategories`, { returnObjects: true })
  const language = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
  const bigCategories = portfolioCategories.slice(0, 2);
  const smallCategories = portfolioCategories.slice(2, 5);

  const scrollTop = () => {
    window.scrollTo({ top: 0, scrollBehavior: 'smooth' });
  };

  return (
    <Wrapper>
      <Fade up>
        <Heading>{t('HomePage.AvailablePortfolioCategories.title')}</Heading>
      </Fade>
      <Fade up>
      <BigSection>
        {
          bigCategories.map(category => (
            <Portfolio key={category.name}>
                <PortfolioPicture>
                  <img src={require(`${category.image}`).default} alt='' role='presentation' />
                </PortfolioPicture>
                {language === 'ja' ? <PortfolioTitleJP>{t(`${category.displayName.toUpperCase()}`)}</PortfolioTitleJP> : <AmountOfPortfolios>{`${category.portfolios.length} ${t(`HomePage.AvailablePortfolioCategories.words.patentsFor`)}`}</AmountOfPortfolios> }
                {language === 'ja' ?  <AmountOfPortfoliosJP>{`${category.portfolios.length} ${t(`HomePage.AvailablePortfolioCategories.words.patentsFor`)}`}</AmountOfPortfoliosJP> : <PortfolioTitle>{t(`${category.displayName.toUpperCase()}`)}</PortfolioTitle> }
                <Description>{t(`${category.description}`)}</Description>
                <Link onClick={scrollTop} to={`/portfolios/${category.name}`}>{t(`HomePage.AvailablePortfolioCategories.words.findOutMore`)}</Link>
            </Portfolio>
          ))
        }
      </BigSection>
      </Fade>
      <Fade up>
        <SmallSection>
          {
            smallCategories.map(category => (
              <Portfolio key={category.name} small='true'>
                <PortfolioPicture small='true'>
                  <img src={require(`${category.image}`).default} alt='' role='presentation' />
                </PortfolioPicture>
                {language === 'ja' ? <PortfolioTitleJP small='true'>{t(`${category.displayName.toUpperCase()}`)}</PortfolioTitleJP> : <AmountOfPortfolios>{`${category.portfolios.length} ${t(`HomePage.AvailablePortfolioCategories.words.patentsFor`)}`}</AmountOfPortfolios> }
                {language === 'ja' ?  <AmountOfPortfoliosJP small='true'>{`${category.portfolios.length} ${t(`HomePage.AvailablePortfolioCategories.words.patentsFor`)}`}</AmountOfPortfoliosJP> : <PortfolioTitle>{t(`${category.displayName.toUpperCase()}`)}</PortfolioTitle> }
                <Description small='true'>{t(`${category.description}`)}</Description>
                <Link onClick={scrollTop} to={`/portfolios/${category.name}`} small='true'>{t(`HomePage.AvailablePortfolioCategories.words.findOutMore`)}</Link>
              </Portfolio>
            ))
          }
        </SmallSection>
      </Fade>
    </Wrapper>
  )
}